import {
  MediaRefFragment,
  PageSection,
  PageSectionFragment,
  PageSectionType,
  PublicSetFragment,
} from '$/GraphQL/schema/schema';

const sectionHasDescription = (section: PageSection): boolean => {
  return section.type
    ? [
        PageSectionType.ImageLeftTextRight,
        PageSectionType.ImageRightTextLeft,
        PageSectionType.ImageBackground,
      ].includes(section.type)
    : false;
};

export const getFirstImageWithTextSection = (
  sections?: PageSectionFragment[] | null
): PageSectionFragment | undefined => {
  return sections?.find(sectionHasDescription);
};

export const getSocialRegistrationMedia = (
  set: PublicSetFragment
): {
  title: string;
  description?: string | null;
  media?: MediaRefFragment | null;
  image?: string | null;
} => {
  const info = set.socialMediaTags;
  return {
    title: info.title ?? '',
    description: info.description,
    media: info.mediaRef,
    image: info.mediaRef?.imageUrl,
  };
};
